import { Expose, plainToClass, ClassTransformOptions } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnColorPalette, SnSize } from '@lib/common/types';

import { SnBadgeConfig } from '../types/badge-config.type';
import { SnBadgePositionX, SnBadgePositionY } from '../types/badge-position.type';

export class SnBadge {
  @Expose() public value: string;
  @Expose() public name: string;
  @Expose() public size: SnSize;
  @Expose() public color: SnColorPalette;

  @Expose() @Default('after') public positionX: SnBadgePositionX;
  @Expose() @Default('above') public positionY: SnBadgePositionY;

  public static fromConfig(data: SnBadgeConfig): SnBadge {
    const config = typeof data === 'string' || typeof data === 'number' ? { value: data } : data;

    const transformOptions: ClassTransformOptions = {
      excludeExtraneousValues: true,
    };

    return plainToClass(SnBadge, config, transformOptions);
  }
}
